import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const propTypes = {
	active: PropTypes.bool.isRequired,
	closeModal: PropTypes.func.isRequired,
	actors: PropTypes.array.isRequired
}

const ActorsReviewModal = (props) => {
	const {active, closeModal, actors} = props;
	return <div className={`modal${active ? ' is-active' : ''}`}>
		<div className="modal-background"/>
		<div className="modal-content">
			<div className="message">
				<div className="message-header">
					<p>Actores estratégicos seleccionados</p>
					<button type="button" onClick={() => closeModal()} className="delete is-medium" aria-label="delete"></button>
				</div>
				<div className="message-body">
					<div className="content">
						<ul>
							{_.map(actors, (actor, k) => <li key={k}>{actor.name}</li>)}
						</ul>
					</div>

					<br/><br/>
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button className="button is-info" type="button" onClick={() => closeModal()}>Cerrar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
}

ActorsReviewModal.propTypes = propTypes;

export default ActorsReviewModal;


// WEBPACK FOOTER //
// ./src/elements/revision/widget/actors_modal.jsx